import { DrawerService } from "./Drawer.service";

export default {
  drawerService: {
    class: DrawerService,
    public: true
  }
};
